package fr.frux.core.maps

/** Ce que le provider a le droit de faire de la Geolocation API, d'apres l'etat connu. */
internal enum class GeolocationAccess {
    /** `getCurrentPosition` peut etre appele sans faire surgir de popup non sollicitee. */
    ALLOWED,

    /** Rien n'a ete accorde : le provider ne demande pas, c'est le role du controleur. */
    MISSING,

    /** Permissions API absente ou en echec, et aucun accord observe. */
    UNAVAILABLE,
}

/**
 * Sur iOS (Safari comme tout WKWebView, donc Chrome iPhone), la Permissions API repond `prompt`
 * meme apres un accord, et `onchange` ne se declenche pas : se fier au seul etat rendait la
 * geolocalisation web inoperante sur iPhone (#464). Un accord constate de visu, c'est-a-dire une
 * position rendue par le `getCurrentPosition` d'une demande au clic, vaut donc `granted` pour le
 * reste de la session, quel que soit l'etat rapporte.
 */
internal fun geolocationAccess(
    permissionState: String?,
    grantObserved: Boolean,
): GeolocationAccess =
    when {
        // Un refus explicite prime : le contournement ne vise qu'un etat fige sur `prompt` (#607).
        permissionState == "denied" -> GeolocationAccess.MISSING

        grantObserved -> GeolocationAccess.ALLOWED

        permissionState == "granted" -> GeolocationAccess.ALLOWED

        permissionState == "prompt" -> GeolocationAccess.MISSING

        else -> GeolocationAccess.UNAVAILABLE
    }

/**
 * Acces d'apres l'etat courant du navigateur. Un refus oublie l'accord observe : si la personne
 * remet ensuite le site sur « demander », l'ancien accord ne doit pas faire surgir de popup.
 */
internal fun currentGeolocationAccess(permissionState: String?): GeolocationAccess {
    if (permissionState == "denied") geolocationGrantObserved = false
    return geolocationAccess(permissionState, geolocationGrantObserved)
}

/** Accord observe dans la session (position rendue apres une demande au clic). Cf. [geolocationAccess]. */
internal var geolocationGrantObserved: Boolean = false
